import { useEffect, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useTranslation, Text, Container, Icon } from '@weareconceptstudio/core';

//* Libs
import { getRelatedPosts } from '@/libs/get-data';

//* Style
import RelatedStyle from './style';

//* Components
import PostItem from '@/modules/Blog/components/Item';

const Related = ({ currentPostId, postCategoryId }) => {
	const { selectedLang } = useTranslation();

	//! State
	const [data, setData] = useState([]);

	useEffect(() => {
		getRelatedPosts({ currentPostId, postCategoryId, lang: selectedLang }).then((res) => setData(res));
	}, [selectedLang, currentPostId, postCategoryId]);

	const relatedPostsData = useMemo(() => {
		return data?.length > 0
			? data.map((item) => (
					<SwiperSlide key={item.id}>
						<PostItem {...item} />
					</SwiperSlide>
				))
			: null;
	}, [data]);

	return data?.length > 0 ? (
		<RelatedStyle>
			<Container isSection>
				<div className='related-top-block'>
					<Text
						className={'h4 uppercase'}
						text={'relatedBlogs'}
					/>

					<div className='slider-icons-blok'>
						<Icon
							name={`left-arrow`}
							className={'swiper-button-prev-3 slider-icon'}
						/>

						<Icon
							name={`right-arrow`}
							className={`swiper-button-next-3 slider-icon`}
						/>
					</div>
				</div>

				<div className={'slider-block'}>
					<Swiper
						slidesPerView={'auto'}
						modules={[Navigation]}
						navigation={{
							prevEl: '.swiper-button-prev-3',
							nextEl: '.swiper-button-next-3',
						}}>
						{relatedPostsData}
					</Swiper>
				</div>
			</Container>
		</RelatedStyle>
	) : null;
};

export default Related;
